import React from 'react';

const Notifications = () => {
  return <h2>Notifications</h2>;
};

export default Notifications;
